/**
 * Alarm Configuration Report settings schema.
 *
 * Run-and-go report (ENGS-677 port): it snapshots the current alarm
 * configuration for every visible monitoring point, so there is nothing for
 * the user to configure. `sections` is intentionally empty -- the report's
 * `#run-options` slot renders only the shared run footer (ActionFooter +
 * RunStatusMessage), and it has no `#create-settings` / `#edit-settings`
 * slots at all.
 */

export default {
    slug: 'alarm-configuration-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />'
        + '<path d="M9 17v1a3 3 0 0 0 6 0v-1" />',
    permission: 'run_alarm_configuration_report',
    title: 'Alarm Configuration',
    description: 'How every point\'s alarms are set up right now, and which ones need attention.',
    info: 'Lists every point you can see with its alarm profile, thresholds, and whether threshold alarms, offline alarms and auto-resolve are on. Flags setup problems: no threshold or offline alarms, no one set to be notified, or an alarm active for over 30 days.',

    sections: [],
}
